import { memo } from 'react';
import { TouchableOpacity, View, Text, Image, StyleSheet } from 'react-native';
import { Exercise } from '@/lib/types';

interface Props {
  exercise: Exercise;
  onPress: (exercise: Exercise) => void;
  actionLabel?: string;
}

/**
 * Card individual de exercicio na biblioteca/lista.
 *
 * Memoizado pra evitar re-render desnecessario em listas grandes.
 * Pra ganho efetivo, pai deve passar `onPress` via `useCallback`.
 */
function ExerciseCardComponent({ exercise, onPress, actionLabel }: Props) {
  return (
    <TouchableOpacity style={styles.card} onPress={() => onPress(exercise)}>
      {exercise.thumbnail_url ? (
        <Image source={{ uri: exercise.thumbnail_url }} style={styles.thumbnail} />
      ) : (
        <View style={styles.placeholder}>
          <Text style={styles.placeholderText}>🏋️</Text>
        </View>
      )}
      <View style={styles.info}>
        <Text style={styles.name}>{exercise.name}</Text>
        <Text style={styles.muscle}>{exercise.muscle_group}</Text>
      </View>
      {actionLabel && <Text style={styles.action}>{actionLabel}</Text>}
    </TouchableOpacity>
  );
}

export const ExerciseCard = memo(ExerciseCardComponent);

const styles = StyleSheet.create({
  card: { flexDirection: 'row', alignItems: 'center', padding: 12, backgroundColor: '#fff', borderRadius: 10, marginBottom: 8, shadowColor: '#000', shadowOpacity: 0.05, shadowRadius: 4, elevation: 2 },
  thumbnail: { width: 56, height: 56, borderRadius: 8, backgroundColor: '#f0f0f0' },
  placeholder: { width: 56, height: 56, borderRadius: 8, backgroundColor: '#f0f0f0', justifyContent: 'center', alignItems: 'center' },
  placeholderText: { fontSize: 24 },
  info: { flex: 1, marginLeft: 12 },
  name: { fontSize: 15, fontWeight: '600', color: '#1A1A1A' },
  muscle: { fontSize: 13, color: '#888888', marginTop: 2 },
  action: { fontSize: 13, color: '#C8102E', fontWeight: '600' },
});
